export class ValidationResult {
    errorMessages: ValidationError[];
    isValid: boolean;    

    constructor() {
        this.isValid = true;
        this.errorMessages = [];
    }   
}

export class ValidationError {
    field: any;
    error: string;

    constructor(field: string, error: string) {
        this.field = field;
        this.error = error;
    }
}

export function getValidationErrorsForCollection(validationErrors: ValidationError[], collectionName: string, index: number) {
    const filteret = validationErrors.filter(v => {
        
        return  v.field.indexOf('[') === 0 &&
        JSON.parse(v.field)[0] === collectionName &&
        JSON.parse(v.field)[1] === index;
    });

    return filteret       
        .map(p => new ValidationError(JSON.parse(p.field)[2], p.error)); 
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/ValidationResult.ts